import React from 'react';
import { Row, Col, Button, Modal, ModalBody, ModalFooter, UncontrolledTooltip, Table , Card, CardBody, Alert } from 'reactstrap'
import { AuthorCollapsable } from './'
import Select from 'react-select'
import  AuthorCourseRow  from './AuthorCourseRow';
import { connect } from 'react-redux'
import { courses } from '../../../redux/actions/courses'
import { get } from 'lodash';
import { PulseLoader } from 'react-spinners';

class AuthorCourseContents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            modal: false,
            editNode: ''
        }
        this.updateName = this.updateName.bind(this);
        this.updateDisplayName = this.updateDisplayName.bind(this);
    }

    componentDidMount(){
        this.props.getCourse(this.props.match.params.courseId)
        this.props.getCourseSubcourses(this.props.match.params.courseId)
    }

    componentDidUpdate(prevProps){
        if(prevProps.courses.creatingSubcourse && !this.props.courses.creatingSubcourse){
            this.props.getCourseSubcourses(this.props.match.params.courseId)
            this.props.getCourse(this.props.match.params.courseId)
        }
    }

    showError(err) {
        this.setState({ error: err }, () => console.log(this.state.error));
        setTimeout(() => {
          this.setState({ error: null });
        }, 1500);
      }
    
      updateName(course, newName, updateState) {
        try {
          const { updateCourseName } = this.props;
          this.validateUpdateCourseName(course.id, newName);
    
          updateCourseName(course.id, newName);
        } catch (err) {
          switch (err) {
            case "NAME_EXIST_ERROR":
              this.showError("Course Name Already Exists");
              break;
            case "EMPTY_FIELD":
              this.showError("Both fields are required");
              break;
            default:
              console.log(err);
          }
          updateState({ name: course.name });
        }
      }
      updateDisplayName(course, newDisplayName, updateState) {
        try {
          const { updateCourseDisplayName } = this.props;
          this.validateUpdateCourseDisplayName(newDisplayName);
          updateCourseDisplayName(course.id, newDisplayName);
        } catch (err) {
          switch (err) {
            case "NAME_EXIST_ERROR":
              this.showError("Course Name Already Exists");
              break;
            case "EMPTY_FIELD":
              this.showError("Both fields are required");
              break;
            default:
              console.log(err);
          }
    
          updateState({ displayName: course.displayName });
        }
      }
      validateUpdateCourseName(courseId, newName) {
        const { courses } = this.props;
        if (newName) {
          courses.forEach(course => {
            if (
              course.name.toUpperCase() === newName.toUpperCase() &&
              course.id !== courseId
            ) {
              throw "NAME_EXIST_ERROR";
            }
          });
        } else {
          throw "EMPTY_FIELD";
        }
      }
    
      validateUpdateCourseDisplayName(displayName) {
        if (!displayName) {
          throw "EMPTY_FIELD";
        }
      }
       
    

    render() {
        const course = get(this.props.courses, 'course' , {})

        return (
            <React.Fragment>
            <Card className="author-courses-container">
            <h3 className="course-heading">Course Editor</h3>
            {this.props.courses.fetchingCourse
                ?  <div className="m-auto"><PulseLoader loading color={'#35a98c'} size={30} /></div>
                :  <Row className="">
                { this.props.courses.course ? <CardBody>
                  <Col>
                <UncontrolledTooltip placement="top" target="NameTH">
                    The internal name of the course. Must be unique. E.g. "ACT
                    Mastery v2"
                  </UncontrolledTooltip>
                <UncontrolledTooltip placement="top" target="DisplayNameTH">
                    The name of the course visible to users. E.g. "ACT Mastery".
                  </UncontrolledTooltip>
                <UncontrolledTooltip placement="top" target="PublishedTH">
                    Whether or not this course is published (licensable and
                    accessible to users).
                  </UncontrolledTooltip>
                <Table>
                    <thead>
                        <tr>
                            <th id="PublishedTH">Published</th>
                            <th id="DisplayNameTH">Course Display Name </th>
                            <th
                                id="NameTH"
                            >
                                Course Name{" "}
                        <i
                                    className={`arrow-up`}
                                />
                            </th>
                            <th id="PublishedTH">Edit Course</th>
                            <th id="LastModifiedTH">Last Modified</th>
                            <th id="ActionTH">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <AuthorCourseRow course={course}
                        active
                        changeName={this.updateName}
                        changeDisplayName={this.updateDisplayName}
                        />
                        <tr className="edit-course-section">
                           <td colSpan="12"  className="edit-course-section"> 
                            <Row className="author-course-edit">
                                <Col>
                                    <Row className="course-list-items mt-3">
                                        <Col>
                                            {this.props.courses.fetchingCourseSubcourses || !this.props.courses.course ?   <div className="m-auto">
                                            <PulseLoader loading color={'#35a98c'} size={30} />
                                            </div> : <AuthorCollapsable {...this.props} />}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                </Col>
                </CardBody> : <Alert color={'danger'}>This course does not exist.</Alert> }
                    </Row> }
                </Card>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        courses : state.courses
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCourse: (courseId) => { dispatch(courses.getCourse(courseId)) },
        getCourseSubcourses: (courseId) => { dispatch(courses.getCourseSubcourses(courseId)) },
        createSubcourse: (subcourse, course) => { dispatch(courses.createSubcourse(subcourse, course)) },
        updateCourseDisplayName : (courseId, newDisplayname)  =>  { dispatch(courses.updateCourseDisplayName(courseId, newDisplayname) ) }
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(AuthorCourseContents)


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorCourseContents.js